import { render, staticRenderFns } from "./Faenas.vue?vue&type=template&id=3d59066f"
import script from "./Faenas.vue?vue&type=script&lang=js"
export * from "./Faenas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports